import applicationContextReducer from './applicationContextReducer';
import modalReducer from './modalReducer';
import spinnerReducer from './spinnerReducer';

export const reducers = {
    applicationContext: applicationContextReducer,
    modal: modalReducer,
    spinner: spinnerReducer, 
};